import { MODAL_ID_DEFAULT } from '../../../../constants/common'
import { MINIMIZED_MODAL_KEY } from '../../../Modal'

export const REQUEST_PROFILE_TAB_EMAILS_MODALS_CONFIG = {
  setEmailFormModal: {
    closer: 'closeEmailFormModal',
    id: MINIMIZED_MODAL_KEY.EMAIL_FORM,
  },
  setModal: { closer: 'closeModal', id: MODAL_ID_DEFAULT },
}
